import fire from './fire';
import { ensureTracking } from './ensureTracking';
import internalTrack from './internalTrack';

const TrackData = (category, action, value) => {
    internalTrack('event', category, action, value);

    if (!window.ApexChatAnalyticsID) {
        return;
    }
    if (!category || !action) {
        if (window.console) {
            console.error('Must provide a category and an action.');
        }
    }

    ensureTracking();
    const data = {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: ApexChatCompanyKey,
        hitCallback() {
            // console.log('Hit processed.', data);
        }
    };

    if (value) {
        data.eventValue = value;
    }

    __apexGA('apex.send', data);

    fire(`${category}:${action}`, {
        key: ApexChatCompanyKey
    });
};
export default TrackData;
